import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PublicIcon from '@material-ui/icons/Public';
// import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';

import AdminCard from '../components/AdminCard.jsx';
import ButtonHeader from '../components/ButtonHeader.jsx';
import AccountBoxMultipleIcon from '../icons/AccountBoxMultipleIcon.jsx';
// import AlarmBellIcon from '../icons/AlarmBellIcon.jsx';
// import CCTVIcon from '../icons/CCTVIcon.jsx';
// import CheckCircleMultipleIcon from '../icons/CheckCircleMultipleIcon.jsx';

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: -theme.spacing(4),
    maxWidth: '100%',
  },
  card: {
    margin: theme.spacing(4),
  },
}));

const AdminPage = () => {
  const classes = useStyles();
  // TODO: below code snippets are required for upcoming stories
  /* const buttonList = [
    { name: 'Update Devices', action: () => {} },
    { name: 'Update Controller(s)', action: () => {} },
  ];
 */
  const settingsList = [
    // TODO: below code snippets are required for upcoming stories
    /* { name: 'Triggers & Procedures', icon: <CheckCircleMultipleIcon />, to: '#' },
    { name: 'User Accounts & User Rights', icon: <SupervisedUserCircleIcon />, to: '#' },
    { name: 'Modules & Plugins', icon: <CCTVIcon />, to: '#' },
    { name: 'Alarms & Maps Settings', icon: <AlarmBellIcon />, to: '#' }, */
    {
      name: 'Cardholder & Card Settings',
      icon: <AccountBoxMultipleIcon />,
      to: '/globalsettings/cardSetting',
    },
    {
      name: 'Global Settings & App Configuration',
      icon: <PublicIcon />,
      to: '/globalsettings/globalSetting',
    },
  ];

  return (
    <>
      {/* TODO: below code snippet is required for upcoming story */}
      {/* <ButtonHeader title="Administrative Resources" buttonList={buttonList} /> */}
      <ButtonHeader title="Administration" />
      <div className={classes.content}>
        {settingsList.map((item) => (
          <AdminCard
            key={item.name}
            className={classes.card}
            name={item.name}
            icon={item.icon}
            to={item.to}
          />
        ))}
      </div>
    </>
  );
};

export default AdminPage;
